export enum FormatEnum {
    Pdf = 'PDF',
    Dat = 'DAT'
  }